export default __webpack_public_path__ + "static/card-7-026741820c38617f65b87e2b4db8363c.png";